import { Component, ElementRef, Input } from '@angular/core';
import { Icon, ZenithAppearance } from '../zenith-enums';

@Component({
    selector: 'app-zenith-toast',
    templateUrl: './zenith-toast.component.html',
})
export class ZenithToastComponent {

    @Input() content: string;
    @Input() appearance: ZenithAppearance;
    @Input() icon?: Icon;

    constructor(private readonly host: ElementRef<HTMLElement>) {
        setTimeout(() => this.onCloseToast(), 6000);
    }

    onCloseToast() {
        this.host.nativeElement.remove();
    }

}
